// TEMP_BRIDGE
module.exports = require("./Button" + ".tsx");
